import React from 'react';

const NotFound = () => {
  return (
    <div className="mt-4 text-center">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;